import { Injectable } from '@angular/core';
import { CurrentUserService } from './auth/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(private currentUserService: CurrentUserService) {}

  languages = [
    {
      code: 'en-US',
      name: 'English',
      flag: 'assets/media/flags/united-states.png',
    },
    {
      code: 'nl-NL',
      name: 'Dutch',
      flag: 'assets/media/flags/netherlands.png',
    },
    { code: 'tr-TR', name: 'Turkish', flag: 'assets/media/flags/turkey.png' },
  ];

  getLanguage(): string {
    const currentUser = this.currentUserService.GetSession();
    if (currentUser) {
      localStorage.setItem('app-lang', currentUser?.selectedLanguageCode);
    }
    return currentUser?.selectedLanguageCode;
  }

  getLanguages() {
    return this.languages;
  }

  getLanguageCode(): string {
    const currentUser = this.currentUserService.GetSession();
    const code = currentUser?.selectedLanguageCode || 'en-US';

    if (currentUser) {
      localStorage.setItem('app-lang', code);
    }
    return code;
  }

  getSelectedLanguage() {
    const code = this.getLanguageCode();
    return (
      this.languages.find((lang) => lang.code === code) || this.languages[0]
    );
  }
}
